import List from './list.vue';
import Full from '@rebuild/materials/shared/question/Full.vue';

export const componentMap = {
	list: List,
	full: Full
};
